<template>
  <div class="main-content">
    <!-- Section: inner-header -->
    <section
      v-if="category != null"
      class="inner-header divider parallax layer-overlay overlay-dark-5 pt-70 img-background-50"
      data-parallax-ratio="0.7"
      :data-bg-img="baseUrl + category.ImageDetail.url"
      v-bind:style="{ backgroundImage: 'url(' + baseUrl + category.ImageDetail.url + ')' }"
    >
      <div class="container pt-100 pb-50">
        <!-- Section Content -->
        <div class="section-content pt-100">
          <div class="row">
            <div class="col-md-12">
              <h3 class="title text-white">{{category.Title}}</h3>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Section: About -->
    <section id="category" v-if="category != null">
      <div class="container pt-70">
        <div class="section-content">
          <div class="row pb-40">
            <!-- <div class="col-md-1">
              <i class="flaticon-boxing-gym-2 font-72 line-height-1"></i>
            </div>-->
            <div class="col-md-12 description no-style">
            <vue-markdown class="font-18 mt-0 " :source="category.Description"></vue-markdown>
              <!-- <h4 class="text-uppercase mt-0 letter-space-3">
                <vue-markdown :source="item.Description"></vue-markdown>{{category.Description}}</h4> -->
            </div>
          </div>
        </div>
      </div>
    </section>


    <!-- Section: Categories -->
    <section id="categories" v-if="programs != null && programs.length > 0">
      <div class="container">
        <div class="row mtli-row-clearfix">
          <div class="col-md-12">
            
     <div
            class="m-10"
            data-pp-message
            data-pp-style-layout="flex"
            data-pp-style-ratio="20x1"
            data-pp-style-color="black">
        </div>

            <div class="itemContainer">
              <div class="item" v-for="program in programs" :key="program.id">
                <div class="class-item box-hover-effect effect1 mb-md-30 bg-lighter">
                  <div class="content">
                    <div class="thumb mb-20"><img v-if="program.MainImage"
                      :alt="program.MainImage.alternativeText"
                      :src="baseUrl + program.MainImage.url"
                      class="img-responsive img-fluid img-fullwidth"/>
                        </div>
                    <div class="text-left flip p-25 pt-0">
                    <h4 class="text-uppercase font-weight-800 line-bottom">{{program.Title}}</h4>
                    <p>{{program.Description}}</p>
                     </div>
                    <a :href="'/payment?ID=' + program.id" class="btn-buy btn btn-dark btn-theme-colored btn-xl">ACQUISTA <b>{{program.Price}}€</b></a>
                  </div>
                </div>
              </div>
              </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Section: Gallery -->
    <section id="gallery">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <!-- Portfolio Gallery Grid -->
            <div
              class="gallery-isotope grid-3 masonry gutter-small clearfix"
              data-lightbox="gallery"
            >
              <div v-if="category != null">
                <!-- Portfolio Item Start -->
                <div
                  class="gallery-item"
                  v-for="galleryImg in category.GalleryImages"
                  :key="galleryImg.id"
                >
                  <a
                    :href="baseUrl + galleryImg.url"
                    data-lightbox="gallery-item"
                    :title="galleryImg.alt"
                  >
                    <img :src="baseUrl + galleryImg.url" alt />
                  </a>
                </div>
              </div>
              <!-- Portfolio Item End -->
            </div>
            <!-- End Portfolio Gallery Grid -->
          </div>
        </div>
      </div>
    </section>

    


  </div>
</template>

<style scoped>
/* #category .description, #program .title {
  text-align: center;
} */
#program img {
 max-height: 200px;
}

.content{
  display: flex;
  flex-direction: column;
  height: 100%;
}

.btn-buy{
  margin-top: auto;
  align-self: center;
  margin-bottom: 20px;
}

.item .class-item{
  border-radius: 5px;
}

.item{
  margin: 1rem;
  display: flex;
  flex: 1 1 28%;
}

.itemContainer{
  display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

#about .title.line-bottom::after {
  height: 2px;
  width: 100%;
}
</style>

<script>
import axios from "axios";
import VueMarkdown from 'vue-markdown'
import { THEMEMASCOT } from "../../public/js/custom.js";

export default {
  name: "Category",
  props: ["CategoryKey"],
  components: {
    VueMarkdown
  },
  data() {
    return {
      category: null,
      programs: null,
      baseUrl: process.env.VUE_APP_API_URL
    };
  },
  async mounted() {
     this.category = await axios
      .get(process.env.VUE_APP_API_URL + "/categories?UrlKey=" + this.CategoryKey)
      .then(response => {
        return JSON.parse(JSON.stringify(response.data))[0];
        
      });

      this.programs = this.category.programs.filter(x => x.IsVisible == true).sort(dynamicSort("Order"));

        THEMEMASCOT.slider.init();
        THEMEMASCOT.widget.init();
  }
};

function dynamicSort(property) {
    var sortOrder = 1;
    if(property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a,b) {
        /* next line works with strings and numbers, 
         * and you may want to customize it to your needs
         */
        var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        return result * sortOrder;
    }
}
</script>